export const theme = {
         primary: "#D4182A",
         secondary: "#1d386b",
         black: "#252525",
         grayBgColor: "#F7F7FF",
         txtColor: "#6c727e",
         error: "#d91e18",
       };
